document.addEventListener('DOMContentLoaded', initAutoplayVideos);
document.addEventListener('shopify:section:load', initAutoplayVideos);

function initAutoplayVideos() {
  var videos = document.querySelectorAll('video');
  if (!videos.length) return;

  videos.forEach(function (v) {
    // מאפיינים שחייבים בשביל autoplay אמין
    v.muted = true;
    v.loop = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');

    // נסה לנגן מיד
    safePlay(v);

    // נסיון חוזר כשהווידאו נכנס לפריים (לעקוף lazy-load)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) safePlay(v); });
      });
      io.observe(v);
    }

    // נסיון נוסף עם אינטראקציה מינימלית של המשתמש (אם הדפדפן מחמיר)
    ['pointerdown', 'touchstart', 'click', 'mouseover'].forEach(function (evt) {
      v.addEventListener(evt, function once() {
        safePlay(v);
        v.removeEventListener(evt, once);
      }, { once: true });
    });
  });
}

function safePlay(video) {
  try {
    var p = video.play && video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* swallow */ });
  } catch (e) { /* ignore */ }
}